// Libs
import classNames from 'classnames/bind';
import { Button, Modal, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './UnderDevelopment.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const UnderDevelopment = (props: Props) => {
  //#region Destructuring Props
  const { isOpen, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div id='underDevelopmentComponent' className={cx('container')}>
        <Typography className={cx('description')}>{t('common_title_under_dev')}</Typography>

        <Stack direction={'row'} justifyContent={'center'}>
          <Button variant='contained' color='primary' className={cx('button')} onClick={onClose}>
            {t('common_action_ok')}
          </Button>
        </Stack>
      </div>
    </Modal>
  );
};

export default UnderDevelopment;
